module.exports = __webpack_public_path__ + "static/media/logo_big.f23959cd.png";